__turbopack_context__.v({
  "expansion-panel": "MarketingSectionBlockMobile-module-scss-module__hk2zya__expansion-panel",
  "expansion-panel-content": "MarketingSectionBlockMobile-module-scss-module__hk2zya__expansion-panel-content",
  "list-container": "MarketingSectionBlockMobile-module-scss-module__hk2zya__list-container",
  "marketing-section-mobile": "MarketingSectionBlockMobile-module-scss-module__hk2zya__marketing-section-mobile",
  "section-title": "MarketingSectionBlockMobile-module-scss-module__hk2zya__section-title",
});
